export default __webpack_public_path__ + "static/DSC_0012-d357c0744f1c6aa2be1515d072001d20.jpg";